export function isMobileValidHr(phone?: string | null): boolean {
  if (!phone) return false;

  // makni sve osim brojeva
  let clean = phone.replace(/\D/g, '');

  // +385 / 00385
  if (clean.startsWith('385')) {
    clean = '0' + clean.substring(3);
  }

  // mora imati 9 ili 10 znamenki
  if (clean.length < 9 || clean.length > 10) return false;

  // prefiksi mobilnih mreža
  const mobilePrefixes = [
    '091', '092', '095', '097', '098', '099'
  ];

  return mobilePrefixes.some(prefix =>
    clean.startsWith(prefix)
  );
}


export function formatMobileHr(value: string): string {
  if (!value) return '';

  let digits = value.replace(/\D/g, '');

  // +385 / 00385
  if (digits.startsWith('385')) {
    digits = '0' + digits.substring(3);
  }

  // max 10 znamenki
  digits = digits.substring(0, 10);

  if (digits.length <= 3) return digits;
  if (digits.length <= 6)
    return `${digits.substring(0, 3)} ${digits.substring(3)}`;

  return `${digits.substring(0, 3)} ${digits.substring(3, 6)} ${digits.substring(6)}`;
}
